angular.module("ainapp")
    .controller("addVendorController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
        function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {


            $scope.PageName = "Add Vendor";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.Cities = [];
            MainService.CitiesInDropdown().then(function (response) {
                $scope.Cities = response.data;
            });

            $scope.ParentList = [];
            MainService.GetVendorParentList().then(function (response) {
                $scope.ParentList = response.data;
            });

            $scope.Employees = [];
            MainService.EmployeesInDropdown().then(function (response) {
                $scope.Employees = response.data;
            })

            $scope.CusDesign = {};
            MainService.CustomDesignsbyType("Vendor").then(function (response) {
                if (response.data != null && response.data != "") {
                    $scope.CusDesign = response.data;
                } else {
                    $scope.CusDesign = {};
                }
            }, function (err) {
            })

            $scope.refreshBranch = function () {
                $scope.branchSelectDataSource = {
                    serverFiltering: true,
                    transport: {
                        read: function (o) {
                            o.success({
                                Data: $scope.Branches
                            });
                        }
                    },
                    schema: {
                        data: "Data"
                    },
                    pageSize: 10
                };

                $scope.selectBranchOptions = {
                    placeholder: "Select Branch...",
                    dataTextField: "Name",
                    dataValueField: "Id",
                    valuePrimitive: true,
                    autoBind: true,
                    dataSource: $scope.branchSelectDataSource
                };

            }


            $scope.udpateData = function (data) {
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.GetAccountById(data).then(function (response) {
                    if (response.data != null) {
                        $scope.CurrentTransAccount = response.data;

                        if (response.data.LicenseExpiryDate != null) {
                            $scope.CurrentTransAccount.LicenseExpiryDate = new Date(response.data.LicenseExpiryDate);
                        }
                        if (response.data.LicenseIssueDate != null) {
                            $scope.CurrentTransAccount.LicenseIssueDate = new Date(response.data.LicenseIssueDate);
                        }

                        if (response.data.IdentityIssueDate != null) {
                            $scope.CurrentTransAccount.IdentityIssueDate = new Date(response.data.IdentityIssueDate);
                        }
                        if (response.data.IdentityExpiryDate != null) {
                            $scope.CurrentTransAccount.IdentityExpiryDate = new Date(response.data.IdentityExpiryDate);
                        }

                        if (response.data.PassportIssueDate != null) {
                            $scope.CurrentTransAccount.PassportIssueDate = new Date(response.data.PassportIssueDate);
                        }
                        if (response.data.PassportExpiryDate != null) {
                            $scope.CurrentTransAccount.PassportExpiryDate = new Date(response.data.PassportExpiryDate);
                        }

                        $scope.VoucherDocs =  $scope.CurrentTransAccount.VoucherDocs ;

                        $scope.CurrentTransAccount.BranchIds = [];
                        angular.forEach($scope.CurrentTransAccount.AccountBranchs, function (e) {
                            $scope.CurrentTransAccount.BranchIds.push(e.BranchId);
                        })

                        $scope.Branches = [];
                        MainService.BranchesInDropdown().then(function (response) {
                            $scope.Branches = response.data;
                            $scope.refreshBranch();
                        }, function (err) {
                            toastr.error("Network Error");
                        })

                    } else {
                        toastr.error("Network Error");
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("Network Error");
                    $.LoadingOverlay("hide");
                });
            }


            $scope.Init = function () {

                MainService.GetCompanyProfile().then(function (response) {
                    $scope.CompanyProfile = response.data;

                    $scope.CountryCosts = [];
                    MainService.CostCenterSubList($scope.CompanyProfile.CostCenterCountryId).then(function (response) {
                        $scope.CountryCosts = response.data;
                    });

                    $scope.StateCosts = [];
                    MainService.CostCenterSubList($scope.CompanyProfile.CostCenterStateId).then(function (response) {
                        $scope.StateCosts = response.data;
                    });

                    $scope.TaxCategoryCosts = [];
                    MainService.CostCenterSubList($scope.CompanyProfile.CostCenterTaxCategoryId).then(function (response) {
                        $scope.TaxCategoryCosts = response.data;
                    });

                    $scope.VatAccTypeCosts = [];
                    MainService.CostCenterSubList($scope.CompanyProfile.CostCenterVatAccountTypeId).then(function (response) {
                        $scope.VatAccTypeCosts = response.data;
                    });
                })

                $scope.CurrentTransAccount = {
                    Name: "",
                    NameAr: "",
                    ParentId: "",
                    IsActive: true,
                    IsGroup: true,
                    Level: 1,
                    AccountTypeId: "",
                    Description: "",

                    PhoneNo: "",
                    MobileNo: "",
                    Email: "",
                    CreditDays: 0,
                    CreditLimit: 0,
                    ContactPerson: "",
                    ContactPersonNo: "",
                    TRNNo: "",
                    VATType: "",
                    LicenseExpiryDate: null,
                    Address: "",
                    CityId: "",
                    VATId: "",
                    FaxNo: "",
                    PassportNo: "",
                    LicenseNo: "",
                    EmployeeId: "",

                    CostCenterCountryId: "",
                    CostCenterStateId: "",
                    CostCenterTaxCategoryId: "",
                    CostCenterVatAccountTypeId: "",

                    AccountContacts: [],
                    AccountAddresses: [],
                    BranchIds: [],

                    LicenseIssueDate: null,
                    LicenseExpiryDate: null,
                    IdentityIssueDate: null,
                    IdentityExpiryDate: null,
                    IdentityIssueDate: null,
                    PassportExpiryDate: null,
                }

                $scope.Contact = {
                    Name: "",
                    EmailId: "",
                    MobileNo1: "",
                    MobileNo2: "",
                    Address1: "",
                    Address2: "",
                    Relation: "",
                    IsActive: true,
                }

                $scope.CurrentTransAccount.AccountContacts.push($scope.Contact);

                $scope.Address = {
                    Name: "",
                    Type: "",
                    EmailId: "",
                    MobileNo1: "",
                    MobileNo2: "",
                    Address1: "",
                    Address2: "",
                    IsActive: true,
                }
                $scope.CurrentTransAccount.AccountAddresses.push($scope.Address);


                $scope.load = 0;
                $scope.ViewVal = 0;

                if ($stateParams.AccountId > 0) {
                    $scope.udpateData($stateParams.AccountId);
                } else {
                    $scope.Branches = [];
                    MainService.BranchesInDropdown().then(function (response) {
                        $scope.Branches = response.data;
                        $scope.refreshBranch();
                    }, function (err) {
                        toastr.error("Network Error");
                    })
                }


            }
            $scope.Init();




            $scope.AddContact = function (data) {
                $scope.Contact = {
                    Name: "",
                    EmailId: "",
                    MobileNo1: "",
                    MobileNo2: "",
                    Address1: "",
                    Address2: "",
                    Relation: "",
                    IsActive: true,
                }
                $scope.CurrentTransAccount.AccountContacts.push($scope.Contact);
            }
            $scope.RemoveContact = function (data) {
                data.IsActive = false;
            }

            $scope.AddAddress = function (data) {
                $scope.Address = {
                    Name: "",
                    Type: "",
                    EmailId: "",
                    MobileNo1: "",
                    MobileNo2: "",
                    Address1: "",
                    Address2: "",
                    IsActive: true,
                }
                $scope.CurrentTransAccount.AccountAddresses.push($scope.Address);
            }
            $scope.RemoveAddress = function (data) {
                data.IsActive = false;
            }


            $scope.goCostcenters = function (data) {
                $state.go("AccountCostCenters", {
                    AccountMasterId: data.Id
                })
            };





            $scope.SelectedDataForDelete = {};
            $scope.DeleteAccType = function (data) {
                if (!$scope.PageAccessInfo.IsRemove) {
                    toastr.info("You Dont Have Access To Delete Data, Please Contact Admin");
                } else {
                    $scope.SelectedDataForDelete = data;
                    $("#deleteModal").modal("show");
                }
            }

            $scope.deleteWithConfirm = function () {
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.DeleteAccountMaster($scope.SelectedDataForDelete.Id).then(function (response) {
                    if (response.data == "Success") {
                        $('#deleteModal').modal('hide');
                        toastr.success("Deleted");
                        $state.go("Vendors");
                        $scope.SelectedDataForDelete = {};
                    } else {
                        toastr.warning(response.data);
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("Network Error");
                    $.LoadingOverlay("hide");
                });
            }


            $scope.SaveData = function () {
                if (!$scope.PageAccessInfo.IsAdd && !$scope.CurrentTransAccount.Id > 0) {
                    toastr.info("You Dont Have Access To Add Data, Please Contact Admin");
                } else if (!$scope.PageAccessInfo.IsEdit && $scope.CurrentTransAccount.Id > 0) {
                    toastr.info("You Dont Have Access To Edit Data, Please Contact Admin");
                } else if ($scope.CurrentTransAccount.Name == "") {
                    toastr.warning("Enter Name");
                } else if ($scope.CurrentTransAccount.MobileNo == "") {
                    toastr.warning("Enter Mobile No");
                } else if ($scope.CompanyProfile.IsCusTRNMandatory && $scope.CurrentTransAccount.TRNNo == "") {
                    toastr.warning("Enter TRN No");
                } else if ($scope.CompanyProfile.IsCusLicenseMandatory && $scope.CurrentTransAccount.LicenseNo == "") {
                    toastr.warning("Enter License No");
                } else {

                    $scope.CurrentTransAccount.AccountBranchs = [];
                    angular.forEach($scope.CurrentTransAccount.BranchIds, function (e) {
                        var tt = {
                            BranchId: e,
                        }
                        $scope.CurrentTransAccount.AccountBranchs.push(tt);
                    })

                    if ($scope.CurrentTransAccount.LicenseExpiryDate != null) {
                        $scope.CurrentTransAccount.LicenseExpiryDateString = $scope.extractDate($scope.CurrentTransAccount.LicenseExpiryDate);
                    }

                    if ($scope.CurrentTransAccount.LicenseIssueDate != null) {
                        $scope.CurrentTransAccount.LicenseIssueDateString = $scope.extractDate($scope.CurrentTransAccount.LicenseIssueDate);
                    }

                    if ($scope.CurrentTransAccount.IdentityIssueDate != null) {
                        $scope.CurrentTransAccount.IdentityIssueDateString = $scope.extractDate($scope.CurrentTransAccount.IdentityIssueDate);
                    }

                    if ($scope.CurrentTransAccount.IdentityExpiryDate != null) {
                        $scope.CurrentTransAccount.IdentityExpiryDateString = $scope.extractDate($scope.CurrentTransAccount.IdentityExpiryDate);
                    }

                    if ($scope.CurrentTransAccount.PassportIssueDate != null) {
                        $scope.CurrentTransAccount.PassportIssueDateString = $scope.extractDate($scope.CurrentTransAccount.PassportIssueDate);
                    }

                    if ($scope.CurrentTransAccount.PassportExpiryDate != null) {
                        $scope.CurrentTransAccount.PassportExpiryDateString = $scope.extractDate($scope.CurrentTransAccount.PassportExpiryDate);
                    }

                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });

                    $scope.CurrentTransAccount.VoucherDocs = $scope.VoucherDocs;

                    MainService.SaveAccountVendor($scope.CurrentTransAccount).then(function (response) {
                        if (response.data == "Success") {
                            toastr.success("Success");
                            $scope.Init();
                        } else {
                            toastr.error(response.data);
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $.LoadingOverlay("hide");
                    });
                }
            }


            /////////////////// Attachment /////////////////

            $scope.VoucherDocs = [];
            $scope.initAttachment = function () {
                $scope.VAttachment = {
                    ExpiryDate: null,
                    FileName: "",
                    FilePath: "",
                    Remarks: "",
                    IsActive: true,
                }
            }
            $scope.initAttachment();

            $scope.addAttachmentList = function () {
                if ($scope.VAttachment.FilePath == "") {
                    toastr.warning("Upload File");
                } else if ($scope.VAttachment.FileName == "") {
                    toastr.warning("Enter File Name");
                } else {
                    $scope.VoucherDocs.push($scope.VAttachment);
                    $scope.initAttachment();
                }
            }

            $scope.removeAttachmentRow = function (data) {
                data.IsActive = false;
            }

            // file upload
            $scope.files = [];
            $scope.getFileDetails = function (e) {
                $scope.files = [];
                $scope.$apply(function () {
                    for (var i = 0; i < e.files.length; i++) {
                        $scope.files.push(e.files[i]);
                    }
                });
                $scope.Load = true;
                $scope.uploadFiles();
            };
            $scope.remove = function (file) {
                var index = $scope.files.indexOf(file);
                $scope.files.splice(index, 1);
            };
            $scope.uploadFiles = function () {
                var data = new FormData();
                for (var i in $scope.files) {
                    data.append("uploadedFile", $scope.files[i]);
                }
                var objXhr = new XMLHttpRequest();
                objXhr.onreadystatechange = function () {
                    if (objXhr.readyState == XMLHttpRequest.DONE) {
                        if (objXhr.responseText != null && objXhr.responseText != "") {
                            $scope.VAttachment.FilePath = objXhr.responseText;
                            if ($scope.VAttachment.FilePath.includes("error")) {
                                $scope.VAttachment.FilePath = "";
                                toastr.error($scope.LanguageData.UploadError);
                            } else {
                                $scope.VAttachment.FilePath = objXhr.responseText;
                                toastr.success($scope.LanguageData.FileUploaded);
                            }
                        } else { }
                    }
                };
                // objXhr.addEventListener("progress", updateProgress, false);
                objXhr.addEventListener("load", transferComplete, false);
                if ($scope.files.length > 0) {
                    toastr.info($scope.LanguageData.FileUploadingPleaseWait);
                    objXhr.open("POST", config.basePath + "UploadFiles");
                    objXhr.send(data);
                } else {
                    toastr.error($scope.LanguageData.UploadError);
                }
            };
            //function updateProgress(e) {
            //    if (e.lengthComputable) {
            //        document.getElementById('pro').setAttribute('value', e.loaded);
            //        document.getElementById('pro').setAttribute('max', e.total);
            //    }
            //}
            function transferComplete(e) {
                $scope.Load = false;
            }


        }])
